export default __webpack_public_path__ + "static/media/crop_free-white-18dp.689037f5.svg";